<template>
  <embedly-video v-if="isVideo"
                 :embedly-iframe-html="embedlyResponse.html"
                 :embedly-thumbnail-url="embedlyResponse.thumbnail_url"
                 :provider="embedlyResponse.provider_name"
                 :bypass-placeholder="bypassPlaceholder" />

  <embedly-image v-else-if="isImage"
                 :embedly-thumbnail-url="embedlyResponse.url"
                 :img-style="embedlyResponse.style"
                 :title="embedlyResponse.title"
                 :height="embedlyResponse.height"
                 :width="embedlyResponse.width"
                 :bypass-placeholder="bypassPlaceholder" />

  <div v-else v-html="embedlyResponse.html" />
</template>

<script>
import EmbedlyImage from './embedly-image'
import EmbedlyVideo from './embedly-video'

export default {
  components: { EmbedlyImage, EmbedlyVideo },

  props: {
    bypassPlaceholder: {
      type: Boolean,
      required: true
    },
    embedlyPrivacyMode: {
      type: Boolean,
      required: true
    },
    embedlyResponse: {
      type: Object,
      required: true
    }
  },

  computed: {
    isVideo() {
      return this.embedlyResponse.type === 'video'
    },

    isImage() {
      return this.embedlyResponse.type === 'photo'
    }
  }
}
</script>
